module.exports = __webpack_public_path__ + "static/media/2020.8.4小手拉大手党员活动.ed067922.jpg";